<form [formGroup]="numberPlatesForm">

  <table class="common-style">
    <tr>
      <th>
        <sc-dictionary-label dictionaryKey="tmc-yard.ui.admin.transport-creation-profiles.active"></sc-dictionary-label>
      </th>
      <th>
        <sc-dictionary-label dictionaryKey="tmc-yard.entity.transport.numberplate"></sc-dictionary-label>
      </th>
      <th></th>
    </tr>
    <tr *ngFor="let numberPlate of numberPlates">
      <td class="centered-column">
        <div (click)="changeActive(numberPlate)">
          <i *ngIf="!numberPlate.active" class="fa-regular fa-square pointer"></i>
          <i *ngIf="numberPlate.active" class="fa-regular fa-square-check pointer"></i>
        </div>
      </td>
      <td>
        {{numberPlate.numberPlate}}
      </td>
      <td>
        <div (click)="this.delete(numberPlate)">
          <sc-icon iconClass="fa-trash pointer"></sc-icon>
        </div>
      </td>
    </tr>
    <tr *ngIf="numberPlates == null || numberPlates.length === 0">
      <td colspan="3" class="centered-column">
        <sc-dictionary-label dictionaryKey="tmc-yard.common.message.no-data"></sc-dictionary-label>
      </td>
    </tr>

  </table>

  <sc-content-spacer vertical></sc-content-spacer>

  <sc-flex>
    <sc-string-field formControlName="newNumberPlate" labelDictionaryKey="tmc-yard.ui.admin.transport-creation-profiles.number-plate"></sc-string-field>
    <sc-content-spacer vertical></sc-content-spacer>
    <button mat-icon-button type="button" [disabled]="!addNewEnabled()" (click)="this.addNewNumberPlate()">
      <i class="fa-light
         fa-plus"></i>
    </button>
  </sc-flex>
</form>
